import { useId } from 'react';

export default function DeliveryDiagram() {
  const id = useId();
  return <figure className="delivery-diagram">
    <svg viewBox="0 0 600 600" role="img" aria-labelledby={`${id}-title ${id}-description`}>
      <title id={`${id}-title`}>相談・設計、開発・実装、運用・改善をつなぐFRiCTONの支援</title>
      <desc id={`${id}-description`}>業務課題を整理して開発し、現場の運用から得た知見を次の改善へ戻します。三つの領域を一つのチームで支援します。</desc>
      <g aria-hidden="true">
        <circle className="delivery-orbit-base" cx="300" cy="300" r="272" />
        <g className="delivery-orbit">
          {[0, 120, 240].map(angle => <g key={angle} transform={`rotate(${angle} 300 300)`}><path d="M307 18 L288 28 L307 38 Z" /><circle cx="330" cy="30" r="4" /></g>)}
        </g>
        <circle className="delivery-disc delivery-disc-plan" cx="300" cy="182" r="134" />
        <circle className="delivery-disc delivery-disc-build" cx="191" cy="371" r="134" />
        <circle className="delivery-disc delivery-disc-run" cx="409" cy="371" r="134" />
        <text className="delivery-title" x="300" y="145" textAnchor="middle">相談・設計</text>
        <text className="delivery-note" x="300" y="179" textAnchor="middle">AI／DXコンサル</text>
        <text className="delivery-title" x="170" y="390" textAnchor="middle">開発・実装</text>
        <text className="delivery-note" x="170" y="424" textAnchor="middle">AI・Web・モバイル</text>
        <text className="delivery-title delivery-light" x="434" y="390" textAnchor="middle">運用・改善</text>
        <text className="delivery-note delivery-light" x="434" y="424" textAnchor="middle">インフラ・業務自動化</text>
        <circle cx="300" cy="307" r="56" fill="white" />
        <text className="delivery-brand" x="300" y="304" textAnchor="middle">FRiCTON</text>
        <text className="delivery-center-note" x="300" y="328" textAnchor="middle">ひとつのチームで</text>
        <rect x="174" y="536" width="252" height="36" rx="18" fill="white" stroke="#a8b6d1" />
        <text className="delivery-feedback" x="300" y="560" textAnchor="middle">現場の声を、次の改善へ</text>
      </g>
    </svg>
    <figcaption>計画だけで終わらせず、実装と運用まで。</figcaption>
  </figure>;
}
